<app-tabla
  [totalCount]="totalCount"
  [datos]="datos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [filtros]="filtros"
  [emptyState]="{
    title: 'Sin pacientes',
    subtitle:
      'Todavía no hay pacientes cargados o ninguno coincide con la búsqueda.',
  }"
></app-tabla>
